.modal {
  padding: 0;

  /* stylelint-disable selector-class-pattern -- Ant Design global classes preserved from emotion source */

  :global(.ant-modal-title) {
    color: var(--x-color-text-primary);
    /* stylelint-disable-next-line value-keyword-case, font-family-no-missing-generic-family-keyword -- `Open Sans` (unquoted) preserved verbatim from emotion source */
    font-family: Open Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: bold;
    line-height: 24px;
  }

  :global(.ant-modal-header) {
    background: var(--x-color-background);
  }

  :global(.ant-form) {
    display: flex;
    flex-direction: column;
  }
  /* stylelint-enable selector-class-pattern */
}

.recipientItem {
  border-bottom: 1px solid var(--x-color-background-darker);
  margin-bottom: 0px;

  /* stylelint-disable selector-class-pattern -- Ant Design global classes preserved from emotion source */

  :global(.ant-form-item-label) > label {
    width: 80px;
    color: var(--x-color-text-primary);
    font-weight: 600;
  }

  :global(.ant-select-selector) {
    border: none;
  }

  :global(.ant-input) {
    border: none;
    box-shadow: none;
    outline: none;
  }

  :global(.ant-form) {
    height: 100%;
  }
  /* stylelint-enable selector-class-pattern */
}

.mailerFormGroup {
  /*
   * Emotion source: `& > :first-child /* ... *\/ { border-top: ... }`.
   * The inline comment is a stylis SSR-warning suppressor only — the selector
   * `& > :first-child` is valid and the rule applies. Preserved as `> :first-child`.
   */

  > :first-child {
    border-top: 1px solid var(--x-color-background-darker);
  }
}

.screenContainer {
  display: flex;
  min-height: 500px;
  align-items: center;
  justify-content: center;
}

.inner {
  margin-top: -50px;
  text-align: center;

  & svg {
    margin: 0;
    font-size: 70px;
  }

  & h2 {
    margin: 0 0 8px 0;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
  }

  & > div > span {
    margin-bottom: 10px;
    color: var(--x-color-text-primary);
  }
}

.success {
  & svg {
    color: var(--x-color-text-green);
  }
}

.failure {
  & svg {
    color: var(--x-color-text-red);
  }
}

.container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
}

.overlay {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
}

.processText {
  color: var(--x-color-text-accent);
  font-size: 16px;
  line-height: 24px;
}

.sendDirectEmailButton {
  /* stylelint-disable-next-line declaration-no-important -- preserved verbatim from emotion source */
  color: var(--x-color-text-primary-disabled) !important;

  &:hover {
    /* stylelint-disable-next-line declaration-no-important -- preserved verbatim from emotion source */
    color: var(--x-color-text-accent) !important;
  }
}

.styledForm {
  height: 100%;
}

.styledTextAreaItem {
  flex-grow: 1;

  /* stylelint-disable selector-class-pattern -- Ant Design global classes preserved from emotion source */

  :global(.ant-form-item-control),
  :global(.ant-form-item-control-input),
  :global(.ant-form-item-control-input-content),
  :global(.ant-form-item-control-input-content textarea) {
    height: 100%;
  }

  :global(.ant-form-item-control-input-content textarea) {
    min-height: 200px;
  }
  /* stylelint-enable selector-class-pattern */
}
